import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, switchMap } from 'rxjs';
import { AtributosIrfeService } from 'src/app/shared/services/atributos-irfe.service';
import { ProjetoCadastro } from '../models/projeto-cadastro.model';
import { PesquisaGeralService } from '../services/pesquisa-geral.service';

@Injectable({
  providedIn: 'root',
})
export class ListAtributosIrfeResolver implements Resolve<boolean> {

  infoProjeto: ProjetoCadastro;
  idProjeto: number;

  constructor(
    private service: AtributosIrfeService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    this.idProjeto = route.parent.parent.params.idProjeto;

    return this.pesquisaGeralService.infoProjeto(this.idProjeto).pipe(
      switchMap(info => {
        this.infoProjeto = info;
  
        return this.service.getListAll(this.infoProjeto.agency_id);
      })
    );
  }
}
